export default "__VITE_ASSET__051b0a43__"